export default "__VITE_ASSET__C___XDPd__"